<template>
  <div class="main-wrap">
    <div class="desc">
      <span>每个时代，每个行业，都有一幅自己的《清明上河图》。彼时匠人的尖端技术，成为驱动行业社会发展的力量。匠心传世，今古如一，联想集团40周年，打造全球最高标准的极致产品，描绘一幅当代制造业的《清明上河图》。从联想AI PC、AI手机的制造，一窥个体部件到整机组装的视觉奇观，看到新AI时代，生产力和生产关系被重新构建，联想集团AI向实，助力实体经济和产业发展，加速迈向人本智能的未来。</span>
    </div>

    <div class="content">
      <a class="video" href="https://b23.tv/6l5WEfx" target="_blank">
        <img class="video-img" src="@/assets/lenovoAIz/pc/video.png" alt="">
      </a>
      <div class="img-1">
        <img src="@/assets/lenovoAIz/pc/bg3.png" alt="">
      </div>
      <div class="img-2">
        <img src="@/assets/lenovoAIz/pc/bg2.png" alt="">
      </div>

      <div class="title">
        <img src="@/assets/lenovoAIz/pc/title.png" alt="">
      </div>

      <div class="bottom">
        <div class="tips">
          每个时代都有自己的《清明上河图》，联想集团用匠心追求极致，绘就40载辉煌璀璨的质造画卷，书写AI新时代的传奇。
        </div>
        <a href="https://b23.tv/6l5WEfx" target="_blank" class="ai-btn">
          立即查看
        </a>
      </div>
    </div>
  </div>
</template>

<script>
// import Swiper from 'swiper';

import vTitle from "../components/title.vue";
import SwiperNews from "../components/swiper-news.vue";
import { request } from '@/assets/common/js/wxShare/api';

export default {
  name: "Index",
  components: {
    vTitle,
  },
  data() {
    return {

    }
  }
};
</script>

<style lang="scss" scoped>
img{
  object-fit: cover;
}
.main-wrap{
  width: 940px;
  margin: 0 auto;
  margin-top: 52px;
  .desc{
    padding: 0 48px;
    font-size: 16px;
    font-weight: 500;
    color: #FEFBE3;
    line-height: 30px;
  }
  .content{
    position: relative;
    margin-top: 28px;
    padding-bottom: 100px;

    .video{
      position: relative;
      z-index: 1;
      width: 100%;
      display: flex;
      justify-content: center;
      .video-img{
        width: 806px;
        height: 489px;
      }
      &:hover{
        cursor: pointer;
      }
    }

    .img-1{
      position: absolute;
      top: 0;
      left: -175px;
      img{
        width: 482px;
        height: 305px;
      }
    }
    .img-2{
      position: absolute;
      top: 48px;
      right: -90px;
      img{
        width: 197px;
        height: 221px;
      }
    }


    .title{
      position: relative;
      width: 100%;
      display: flex;
      justify-content: center;
      img{
        width: 200px;
        height: 29px;
      }
    }

    .bottom{
      position: relative;
      margin-top: 13px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      font-weight: 500;
      font-size: 16px;
      color: #FEFBE3;
      .tips{

      }

      .ai-btn{
        margin-top: 41px;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 197px;
        height: 47px;
        color: #464134;
        background-image: url("~@/assets/lenovoAIz/pc/btn.png");
        background-size: cover;

        &:hover{
          cursor: pointer;
        }
      }
    }
  }

}

.swiper{
  height:100px;
}
</style>